export var Emotions = {
    DEFAULT: null,
    ANGRY: "Angry",
    CONFUSED: "Confused",
    EXCITED: "Excited",
    RAGE: "Rage",
    CHEEKY: "Cheeky",
    DEFEATED: "Defeated",
    PUZZLED: "Puzzled",
    HAPPY: "Happy",
    SAD: "Sad"
};
export var Backgrounds = {
    TRANSPARENT: "transparent",
    BLOCKED: "#000"
};
export var Slots = {
    ONE: "ONE",
    TWO: "TWO",
    THREE: "THREE",
    FOUR: "FOUR"
};
